import type { IconSvgObject } from './types';

const ArrowMoveDownLeftIcon: IconSvgObject = [
  ["path", { d: "M20 3V15.9999C20 17.1044 19.1046 17.9999 18 17.9999L4 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 21L4 18L7 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowMoveDownLeftIcon;
